globalThis.backoffice = globalThis.backoffice || {};

backoffice.Comments = (function()
{
  function Comments($container) {
    this.events();
  }

  Comments.prototype = {
    events: function() {
      var self = this;

      $('body').on('click', '.delete-comment', function(e) {
        var $this = $(this),
            url = $this.data('source');

        if(url && confirm('Êtes-vous sûr de vouloir supprimer définitivement ce commentaire ?')) {
          $.post(url, { _method: 'DELETE' }, function(data) {
            if(data.response) {
              var $comment = $this.closest('.media'),
                  id = $comment.data('comment-id');

              $comment.fadeOut();

              $('.media[data-comment-id=' + id + ']').remove();
            }
          });
        }
      });
    }
  }

  return Comments;
})();
